import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'app-tentative-schedule-details',
  templateUrl: './tentative-schedule-details.component.html',
  styleUrls: ['./tentative-schedule-details.component.scss']
})
export class TentativeScheduleDetailsComponent implements OnInit {
  TentativeDetailsForm: FormGroup;
  TentativeScheduleList: any;
  filteredTentativeSchedule: any;
  dialogRef: MatDialogRef<any>;
  collegeList: any;
  filteredCollegeList: any;
  UserCollege: string;
  userPermission: any;
  DateArray: FormArray;
  arr: [];
  tsmlist: any;
  errMsg: any;
  submitpayload: any;
  APIService: string;
  currentdate: Date;
  date: string;
  deletedRows: any[] = [];
  coursesList: any;
  selectedCourseName: any;
  selectedTentativeDate: any;
  allTsdIds: any[];
  filteredTsmList: any;
  filteredCoursesList: any;
  SrNoList: any;
  filteredSrNoList: any;
  selectedSerialNo: any;
  CircularId: any;
  originalTentativeDate: any;
  constructor(
    public fb: FormBuilder,
    private modalPopupService: ModalpopService,
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    public datepipe: DatePipe,
    private httpClient: HttpClient,
    public router: Router,
    private datePipe: DatePipe,
  ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.arr = [];
    this.CircularId = 0
    this.date = this.datepipe.transform(this.currentdate, 'yyyy-MM-dd');
    this.currentdate = new Date();
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.TentativeDetailsForm = this.fb.group({
      TsmCircularId: new FormControl(''),
      TsdId: new FormControl(''),
      TenCircularNo: new FormControl('', [Validators.required]),
      SrNo: new FormControl('', [Validators.required]),
      // TenCircularDate: new FormControl(''),
      // TenCourses: new FormControl(''),
      DateArray: new FormArray([]),
    });
    // this.addNewRow();
    this.fetchTentative();
    this.fetchCollege();
    this.getTSM();
  }

  fetchTentative() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'TSD';
    this.umsService.getCode(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.TentativeScheduleList = res.data;
        this.filteredTentativeSchedule = this.TentativeScheduleList.slice();
      }
      else {
        this.spinner.hide();
        this.TentativeScheduleList = [];
        this.filteredTentativeSchedule = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
  fetchCollege() {
    // if (this.userPermission[0].CgUi == 'C') {
    //   this.UserCollege = this.userPermission[0].CgId;
    // }
    // else {
    //   this.UserCollege = ''
    // }
    // this.spinner.show();
    const payload = {};
    payload['CdType'] = 'RC';
    this.umsService.getCode(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = []
      this.filteredCollegeList = []
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });

  }

  getControls() {
    return (this.TentativeDetailsForm.get('DateArray') as FormArray).controls;
  }
  addNewRow() {
    const creds = this.TentativeDetailsForm.controls.DateArray as FormArray;
    const newSrNo = creds.length + 1;
    creds.push(
      this.fb.group({
        TsdId: new FormControl(''),
        TentativeSchedule: new FormControl('', [Validators.required]),
        AtCollege: new FormControl('', [Validators.required]),
        AtRegionalCenter: new FormControl(''),
        regionalCenterArray: new FormArray([]),
      })
    );
    this.addNewRegionalCenterRow(0)
  }
  addNewRow2() {
    this.arr = this.TentativeDetailsForm.controls.DateArray.value
    this.DateArray = this.TentativeDetailsForm.get('DateArray') as FormArray;
    if (this.DateArray.invalid) {
      this.DateArray.controls.forEach(element => {
        element.get('TentativeSchedule').markAsTouched();
        element.get('AtCollege').markAsTouched();
        const regionalCenters = element.get('regionalCenterArray') as FormArray;
        regionalCenters.controls.forEach(center => {
          // center.get('AtUniversityCenters').markAsTouched();
          center.get('AtUniversity').markAsTouched();
          center.get('AtUniversityTime').markAsTouched();
        });
        // element.get('AtRegionalCenter').markAsTouched();
      })
    }
    else {
      this.arr = this.TentativeDetailsForm.controls.DateArray.value
      const creds = this.TentativeDetailsForm.controls.DateArray as FormArray;
      const newSrNo = creds.length + 1;
      creds.push(
        this.fb.group({
          TsdId: new FormControl(''),
          TentativeSchedule: new FormControl('', [Validators.required]),
          AtCollege: new FormControl('', [Validators.required]),
          AtRegionalCenter: new FormControl(''),
          regionalCenterArray: this.fb.array([
            this.fb.group({
              AtUniversity: new FormControl('', [Validators.required]),
              AtUniversityCenters: new FormControl(''),
              AtUniversityTime: new FormControl('', [Validators.required]),

            })
          ]),
        })
      );
    }

  }
  getRegionalCenterControls(index: number) {
    const dateArray = this.TentativeDetailsForm.controls.DateArray as FormArray;
    const selectedRow = dateArray.at(index); // Get the selected row (index)
    return (selectedRow.get('regionalCenterArray') as FormArray).controls;
  }

  addNewRegionalCenterRow(index: number) {
    const dateArray = this.TentativeDetailsForm.controls.DateArray as FormArray;
    const selectedRow = dateArray.at(index); // Get the selected row (index)
    const regionalCenterArray = selectedRow.get('regionalCenterArray') as FormArray;
    if (regionalCenterArray.invalid) {
      regionalCenterArray.controls.forEach(element => {
        // element.get('AtUniversityCenters').markAsTouched();
        element.get('AtUniversity').markAsTouched();
        element.get('AtUniversityTime').markAsTouched();
      })
    }
    else {
      regionalCenterArray.push(
        this.fb.group({
          TsdId: new FormControl(''),
          AtUniversityCenters: new FormControl(''),
          AtUniversity: new FormControl('', [Validators.required]),
          AtUniversityTime: new FormControl('', [Validators.required]),
        })
      );
    }
    // Add a new row to the regionalCenterArray for the selected row

  }

  deleteRegionalCenterRow(index: number, rowIndex: number): void {
    const dateArray = this.TentativeDetailsForm.controls.DateArray as FormArray;
    const selectedRow = dateArray.at(index); // Get the selected row (index)
    const regionalCenterArray = selectedRow.get('regionalCenterArray') as FormArray;

    if (regionalCenterArray.length > 1) {
      const deletedData = regionalCenterArray.at(rowIndex).value;
      this.deletedRows.push(deletedData); // Store deleted data
      regionalCenterArray.removeAt(rowIndex);  // Removes the specified row from regionalCenterArray
    } else {
      let data = {}
      data['message'] = "First Row Can Not Be Deleted"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    }

  }

  deleteRow(index: number) {
    let formArray = this.TentativeDetailsForm.get("DateArray") as FormArray;
    if (formArray.length === 1) {
      // Prevent deleting if only one row remains
      let data = {
        message: "First Row Cannot Be Deleted",
        title: "Information",
        icon: "fas fa-check"
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    } else {
      // Store deleted row data (optional)
      let deletedRow = formArray.at(index).value;
      this.deletedRows.push(deletedRow);
      console.log('deletedRows', this.deletedRows)
      // Remove row from form array
      formArray.removeAt(index);
      console.log("Deleted row at index:", index);
      console.log("Total rows after deletion:", formArray.length);
    }
  }
  isSelected(scheduleCode: string, currentIndex: number): boolean {
    return this.TentativeDetailsForm.get('DateArray')?.value
      .some((row: any, index: number) => index !== currentIndex && row.TentativeSchedule === scheduleCode);
  }
  // isOptionDisabled(CdDesc: string, i): boolean {
  //   this.arr = this.TentativeDetailsForm.controls.DateArray.value
  //   const selectedUserId = this.arr[i]['TentativeSchedule'];
  //   return selectedUserId === CdDesc;
  // }

  isCollegeSelectedInRow(collegeCode: string, rowIndex: number, colIndex: number): boolean {
    const dateArray = this.TentativeDetailsForm.get('DateArray') as FormArray;
    const row = dateArray.at(rowIndex) as FormGroup;
    const regionalCenterArray = row.get('regionalCenterArray') as FormArray;

    // Check only previous inputs within the same row
    return regionalCenterArray.controls
      .slice(0, colIndex) // Ensures only previous fields in this row are checked
      .some(control => control.value.AtUniversityCenters.includes(collegeCode));
  }

  getTSM() {
    this.spinner.show();
    const payload = {};
    payload['TsmCircularNumber'] = '';
    payload['TsmCircularDate'] = '';
    payload['TsmSnNo'] = '';
    payload['TsmScheduleType'] = '';
    this.umsService.getTentativeMaster(payload).subscribe(res => {
      console.log('res.data', res.data)
      this.spinner.hide();
      this.tsmlist = res.data;
      this.filteredTsmList = this.tsmlist.slice();
      // this.totalItems = res.data[0].TotalRecords;

    });
  }

  fetchCircularDate(item) {
    // this.TentativeDetailsForm.controls.TenCircularDate
    // this.TentativeDetailsForm.controls['TenCircularDate'].setValue(item);
    this.SrNoList = []; // Reset course list
    this.selectedSerialNo = null; // Reset selected course name
    this.selectedTentativeDate = null; // Reset selected date
  }

  convertUTCToIST(dateString: string): string {
    const utcDate = new Date(dateString);
    // Convert UTC to IST manually
    const istOffset = 5.5 * 60 * 60 * 1000; // IST is UTC +5:30
    const istDate = new Date(utcDate.getTime() + istOffset);
    // Format the IST date in the required format
    const year = istDate.getFullYear();
    const month = String(istDate.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const day = String(istDate.getDate()).padStart(2, '0');
    const hours = String(istDate.getHours()).padStart(2, '0');
    const minutes = String(istDate.getMinutes()).padStart(2, '0');
    const seconds = String(istDate.getSeconds()).padStart(2, '0');
    const milliseconds = String(istDate.getMilliseconds()).padStart(3, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
  }

  submit() {
    this.DateArray = this.TentativeDetailsForm.get('DateArray') as FormArray;
    if (this.DateArray.invalid) {
      this.DateArray.controls.forEach(element => {
        element.get('AtCollege').markAsTouched();
        // element.get('AtRegionalCenter').markAsTouched();
        element.get('TentativeSchedule').markAsTouched();
        // Mark regionalCenterArray fields as touched
        const regionalCenters = element.get('regionalCenterArray') as FormArray;
        regionalCenters.controls.forEach(center => {
          // center.get('AtUniversityCenters').markAsTouched();
          center.get('AtUniversity').markAsTouched();
          center.get('AtUniversityTime').markAsTouched();
        });
      });
      // return;  // Stop submission if form is invalid
    }
    if (this.TentativeDetailsForm.invalid) {
      this.TentativeDetailsForm.get('TenCircularNo').markAsTouched();
      this.TentativeDetailsForm.get('SrNo').markAsTouched();
      // this.TentativeDetailsForm.get('TenCircularDate').markAsTouched();
      // this.TentativeDetailsForm.get('TenCourses').markAsTouched();
      return;
    }
    this.DeleteTentativeDetails();
  }

  // DeleteTentativeDetails() {
  //   this.spinner.show();
  //   this.submitpayload = this.TentativeDetailsForm.value;

  //   if (!this.allTsdIds || this.allTsdIds.length === 0) {
  //     console.log("No existing TsdIds found. Proceeding with direct insert...");
  //     this.spinner.hide();
  //     this.insertTentativeDetails();
  //     return;
  //   }

  //   const allDataToDelete = this.allTsdIds
  //     .filter(row => row.SrNo === this.submitpayload.SrNo) // Filter by SrNo
  //     .map(row => ({
  //       ...row,
  //       TenCircularNo: this.submitpayload.TenCircularNo,
  //       SrNo: this.submitpayload.SrNo.SrNo // Ensure SrNo is correctly assigned
  //     }));

  //   const options = {
  //     headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  //     body: allDataToDelete,
  //   };

  //   console.log('Data to Delete:', allDataToDelete);

  //   this.httpClient.delete(this.APIService + '/inputs/TentativeScheduleDetails', options).subscribe(
  //     (response) => {
  //       this.spinner.hide();
  //       if (response['status'] === true) {
  //         this.allTsdIds = [];
  //         this.insertTentativeDetails();
  //       } else {
  //         const data = {
  //           message: response['message'],
  //           title: 'Information',
  //           icon: 'fas fa-check'
  //         };
  //         this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //       }
  //     },
  //     (ERROR: HttpErrorResponse) => {
  //       this.spinner.hide();
  //       const data = {
  //         message: ERROR.error.message,
  //         title: 'Information',
  //         icon: 'fas fa-close'
  //       };
  //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //     }
  //   );
  // }

    DeleteTentativeDetails() {
      this.spinner.show();
      this.submitpayload = this.TentativeDetailsForm.value;
      let abcd = this.TentativeDetailsForm.get('DateArray') as FormArray;
      console.log('abcd', abcd);
      console.log('deletedRows', this.deletedRows)
      if (!this.allTsdIds || this.allTsdIds.length === 0) {
        console.log("No existing IDs found, calling save API directly...");
        this.spinner.hide();
        this.insertTentativeDetails(); // No data to delete, so insert directly
        return;
      }
      // const allDataToDelete = [
      //   ...this.allTsdIds, // Include all fetched TsdId values

      // ].filter(row => row.SrNo === this.submitpayload.SrNo) // Filter by SrNo
      // .map(row => ({
      //   ...row,
      //   TenCircularNo: this.submitpayload.TenCircularNo,
      //   SrNo: this.submitpayload.SrNo.SrNo // Ensure SrNo is correctly assigned
      // }));

      const allDataToDelete = [
        ...this.allTsdIds,
      ].map(row => ({
        ...row,
        TenCircularNo: this.submitpayload.TenCircularNo,
        SrNo: this.submitpayload.SrNo.SrNo // Ensure SrNo is correctly assigned
      }));
      // const allDataToDelete = this.allTsdIds
      // .filter(row => row.SrNo === this.submitpayload.SrNo) // Filter by SrNo
      // .map(row => ({
      //   ...row,
      //   TenCircularNo: this.submitpayload.TenCircularNo,
      //   SrNo: this.submitpayload.SrNo.SrNo // Ensure SrNo is correctly assigned
      // }));

  // const selectedCourseCode = this.submitpayload.TenCourses.CoCode; // Get the currently selected course code

  // const allDataToDelete = this.allTsdIds.filter(row => row.TenCourses === selectedCourseCode)
  //   .map(row => ({
  //     ...row
  //   }));

      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        body: allDataToDelete, // Send both remaining and deleted rows
      };
      console.log('allDataToDelete',allDataToDelete)
      // return
      this.httpClient.delete(this.APIService + '/inputs/TentativeScheduleDetails', options).subscribe(
        (response) => {
          this.spinner.hide();
          if (response['status'] === true) {
            this.allTsdIds = []; // Clear old IDs after successful deletion
            this.insertTentativeDetails(); // Reload data if needed
          } else {
            const data = {
              message: response['message'],
              title: 'Information',
              icon: 'fas fa-check'
            };
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);


          }
        },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          const data = {
            message: ERROR.error.message,
            title: 'Information',
            icon: 'fas fa-close'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      );
    }

    // convertUTCToIST(dateString: string): string {
    //   const utcDate = new Date(dateString); // Convert string to Date object
    //   // Directly use the date pipe with 'Asia/Kolkata' time zone
    //   return this.datePipe.transform(utcDate, 'dd/MM/yyyy h:mm:ss a', 'Asia/Kolkata') || '';
    // }
  convertISTToUTC(dateString: string): string {
    if (!dateString) return ''; // Ensure it doesn't break for empty values

    let istDate = new Date(dateString); // Convert string to Date object
    let utcDate = new Date(istDate.getTime() - (5.5 * 60 * 60 * 1000)); // Convert IST to UTC
    return utcDate.toISOString(); // Return in ISO format
  }

  formatDateTime(dateString: string): string {
    if (!dateString) return '';
  
    let date = new Date(dateString);
    if (isNaN(date.getTime())) return ''; // Handle invalid dates
  
    // Format as DD/MM/YYYY HH:mm
    let day = String(date.getDate()).padStart(2, '0');
    let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    let year = date.getFullYear();
    let hours = String(date.getHours()).padStart(2, '0');
    let minutes = String(date.getMinutes()).padStart(2, '0');
  
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }
  
  insertTentativeDetails() {
    // this.spinner.show();
    console.log('hiii')
    this.submitpayload = this.TentativeDetailsForm.value;
    console.log(' this.submitpayload', this.submitpayload)
    let abcd = this.TentativeDetailsForm.get('DateArray') as FormArray;
    let payload = abcd.value.map(element => ({
      // TsmCircularId: this.submitpayload.TenCircularNo.TsmCircularId,
      TsdId: element.TsdId,
      TenCircularNo: this.submitpayload.TenCircularNo.TsmCircularNumber,
      SrNo: this.submitpayload.SrNo.SrNo,
      // TenCircularDate: this.submitpayload.TenCircularDate ? this.submitpayload.TenCircularDate : '',
      // TenCourses: this.submitpayload.TenCourses ? this.submitpayload.TenCourses : '',
      // AtCollege: this.convertUTCToIST(element.AtCollege),
      AtCollege: this.datepipe.transform(this.convertUTCToIST(element.AtCollege), 'yyyy-MM-dd'),
      // AtRegionalCenter: this.convertUTCToIST(element.AtRegionalCenter),
      // AtRegionalCenter: element.AtRegionalCenter ? this.convertUTCToIST(element.AtRegionalCenter) : '', // Ensure empty string if falsy
      AtRegionalCenter: element.AtRegionalCenter ? this.datepipe.transform(this.convertUTCToIST(element.AtRegionalCenter), 'yyyy-MM-dd') : '',
      TentativeSchedule: element.TentativeSchedule,
      TsmCircularId: this.CircularId,
      // RegionalCenters: element.regionalCenterArray.map(center => ({
      //   // AtUniversityCenters: center.AtUniversityCenters,
      //   AtUniversityCenters: Array.isArray(center.AtUniversityCenters)
      //     ? center.AtUniversityCenters.join(',')  // Convert array to comma-separated string
      //     : center.AtUniversityCenters || '',  // Keep as is if not an array
      //   AtUniversity: this.convertUTCToIST(center.AtUniversity),
      //   // TsdId: center.TsdId
      // }))
      RegionalCenters: element.regionalCenterArray.map(center => {
        return {

          AtUniversityCenters: center.AtUniversityCenters
            ? (Array.isArray(center.AtUniversityCenters)
              ? center.AtUniversityCenters.join(',')
              : center.AtUniversityCenters)
            : '',  // Ensure an empty string instead of omitting it
          // AtUniversity: center.AtUniversity,
          AtUniversity: this.datepipe.transform(this.convertUTCToIST(center.AtUniversity), 'yyyy-MM-dd'),
          AtUniversityTime: center.AtUniversityTime
        };
      })
    }));
    console.log('TsmCircularId', this.CircularId);

    console.log('Final Payload:', payload);
    this.umsService.AddTentativeDetails(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status === false) {
        this.errMsg = res.message;
        let data = {
          message: this.errMsg,
          title: 'Alert',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.ngOnInit();
      } else {
        let data = {
          message: "Submitted Successfully",
          title: 'Information',
          icon: 'fas fa-check'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.SrNoList = []; // Reset courses list
        this.selectedSerialNo = null; // Reset selected course name
        this.selectedTentativeDate = null; // Reset selected date
        abcd.clear(); // Clear old values
        this.TentativeDetailsForm.reset();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.errMsg = ERROR.error.message;
      let data = {
        message: this.errMsg,
        title: 'Alert',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
    );
  }
  // prepopulatedData() {
  //   console.log('hiiii');
  //   this.DateArray = this.TentativeDetailsForm.get('DateArray') as FormArray;
  //   this.DateArray.clear(); // Clear old data
  //   console.log('this.TentativeDetailsForm', this.TentativeDetailsForm);

  //   let payload = {
  //     TenCircularNo: this.TentativeDetailsForm.value.TenCircularNo,
  //     TenCircularDate: this.TentativeDetailsForm.value.TenCircularDate,
  //     TenCourses: this.TentativeDetailsForm.value.TenCourses.CoCode
  //   };

  //   console.log('payload', payload);

  //   this.umsService.getTentativeDetails(payload).subscribe(res => {
  //     console.log('res.data', res.data);

  //     if (res.status && Array.isArray(res.data) && res.data.length) {
  //       this.DateArray.clear(); // Clear again before pushing new data
  //       this.allTsdIds = []; // Store all TsdId values

  //       // Group by TentativeSchedule
  //       const groupedData = {};
  //       res.data.forEach(element => {
  //         if (element.TsdId) {
  //           this.allTsdIds.push({ TsdId: element.TsdId }); // Collect all TsdId values
  //         }

  //         const key = element.TentativeSchedule;

  //         if (!groupedData[key]) {
  //           groupedData[key] = {
  //             TentativeSchedule: element.TentativeSchedule,
  //             AtCollege: element.AtCollege,
  //             AtRegionalCenter: element.AtRegionalCenter,
  //             regionalCenterArray: []
  //           };
  //         } else {
  //           // Merge AtCollege and AtRegionalCenter values if they are different
  //           if (!groupedData[key].AtCollege.includes(element.AtCollege)) {
  //             groupedData[key].AtCollege += `, ${element.AtCollege}`;
  //           }
  //           if (!groupedData[key].AtRegionalCenter.includes(element.AtRegionalCenter)) {
  //             groupedData[key].AtRegionalCenter += `, ${element.AtRegionalCenter}`;
  //           }
  //         }

  //         // Handle RegionalCenters array
  //         if (element.AtUniversityCenters) {
  //           groupedData[key].regionalCenterArray.push({
  //             TsdId: element.TsdId,
  //             // AtUniversityCenters: element.AtUniversityCenters.split(','), // Convert CSV to array
  //             AtUniversityCenters: element.AtUniversityCenters
  //             ? element.AtUniversityCenters.split(',')  // Convert CSV to array
  //             : [], // Default to an empty array if falsy
  //             AtUniversity: element.AtUniversity
  //           });
  //         }
  //       });

  //       // Now push grouped data into form array
  //       Object.values(groupedData).forEach((group: any) => {
  //         const rowGroup = this.fb.group({
  //           AtCollege: new FormControl(group.AtCollege, [Validators.required]),
  //           AtRegionalCenter: new FormControl(group.AtRegionalCenter),
  //           TentativeSchedule: new FormControl(group.TentativeSchedule, [Validators.required]),
  //           regionalCenterArray: this.fb.array([])
  //         });

  //         const regionalCenterArray = rowGroup.get('regionalCenterArray') as FormArray;
  //         group.regionalCenterArray.forEach(center => {
  //           regionalCenterArray.push(this.fb.group({
  //             TsdId: new FormControl(center.TsdId),
  //             AtUniversityCenters: new FormControl(center.AtUniversityCenters || ''),
  //             AtUniversity: new FormControl(center.AtUniversity)
  //           }));
  //         });

  //         this.DateArray.push(rowGroup);
  //       });

  //       console.log('All collected TsdIds:', this.allTsdIds);

  //     } else {
  //       // Reset form if no data found
  //       this.DateArray.clear();
  //       this.addNewRow();
  //     }
  //   });
  // }

  prepopulatedData() {
    console.log('hiiii');
    this.DateArray = this.TentativeDetailsForm.get('DateArray') as FormArray;
    this.DateArray.clear(); // Clear old data
    console.log('this.TentativeDetailsForm', this.TentativeDetailsForm);

    let payload = {
      // TsmCircularId: this.TentativeDetailsForm.value.TenCircularNo.TsmCircularId,
      TenCircularNo: this.TentativeDetailsForm.value.TenCircularNo.TsmCircularNumber,
      SrNo: this.TentativeDetailsForm.value.SrNo.SrNo,
      // TenCircularDate: this.TentativeDetailsForm.value.TenCircularDate,
      // TenCourses: this.TentativeDetailsForm.value.TenCourses,
    };

    console.log('payload', payload);

    this.umsService.getTentativeDetails(payload).subscribe(res => {
      console.log('res.data', res.data);

      if (res.status && Array.isArray(res.data) && res.data.length) {
        this.allTsdIds = res.data.map(item => item.TsdId ? { TsdId: item.TsdId } : null).filter(Boolean);
        console.log('Stored TsdIds:', this.allTsdIds);
        this.DateArray.clear(); // Clear again before pushing new data
        // this.allTsdIds = []; // Store all TsdId values

        // Group by TentativeSchedule
        const groupedData = {};
        res.data.forEach(element => {
          // if (element.TsdId) {
          //   this.allTsdIds.push({ TsdId: element.TsdId }); // Collect all TsdId values
          // }

          const key = element.TentativeSchedule;

          if (!groupedData[key]) {
            groupedData[key] = {
              TentativeSchedule: element.TentativeSchedule,
              AtCollege: element.AtCollege, // Ensure empty value if missing
              AtRegionalCenter: element.AtRegionalCenter || '', // Ensure empty value if missing
              regionalCenterArray: []
            };
          }

          // Handle RegionalCenters array, even if empty
          groupedData[key].regionalCenterArray.push({
            TsdId: element.TsdId || '', // Default to empty string if missing
            AtUniversityCenters: element.AtUniversityCenters
              ? element.AtUniversityCenters.split(',')  // Convert CSV to array
              : [], // Default to an empty array if falsy
            AtUniversity: element.AtUniversity, // Default to empty if missing
            AtUniversityTime: element.AtUniversityTime
          });
        });
        const parseDate = (dateString: string): Date | null => {
          if (!dateString) return null;

          const parts = dateString.split('/'); // Split DD/MM/YYYY
          if (parts.length !== 3) return null;

          const day = parseInt(parts[0], 10);
          const month = parseInt(parts[1], 10) - 1; // Months are 0-based in JS
          const year = parseInt(parts[2], 10);

          return new Date(year, month, day); // Convert to JS Date object
        };
        // Now push grouped data into form array
        Object.values(groupedData).forEach((group: any) => {
          const rowGroup = this.fb.group({
            // AtCollege: new FormControl(group.AtCollege, [Validators.required]),
            // AtCollege: new FormControl(this.datepipe.transform(group.AtCollege, 'yyyy-MM-dd'), [Validators.required]),
            AtCollege: new FormControl(this.datepipe.transform(parseDate(group.AtCollege), 'yyyy-MM-dd'), [Validators.required]),
            // AtRegionalCenter: new FormControl(group.AtRegionalCenter || ''),
            // AtRegionalCenter: new FormControl(group.AtRegionalCenter ? this.datepipe.transform(group.AtRegionalCenter, 'yyyy-MM-dd') : '',),
            AtRegionalCenter: new FormControl(group.AtRegionalCenter ? this.datepipe.transform(parseDate(group.AtRegionalCenter), 'yyyy-MM-dd') : '',),
            TentativeSchedule: new FormControl(group.TentativeSchedule, [Validators.required]),
            regionalCenterArray: this.fb.array([])
          });

          const regionalCenterArray = rowGroup.get('regionalCenterArray') as FormArray;

          if (group.regionalCenterArray.length > 0) {
            group.regionalCenterArray.forEach(center => {
              regionalCenterArray.push(this.fb.group({
                TsdId: new FormControl(center.TsdId),
                AtUniversityCenters: new FormControl(center.AtUniversityCenters.length ? center.AtUniversityCenters : ''), // Show empty string if empty
                // AtUniversity: new FormControl(this.convertISTToUTC(center.AtUniversity)),
                AtUniversity: new FormControl(this.datepipe.transform(parseDate(center.AtUniversity), 'yyyy-MM-dd'), [Validators.required]),
                AtUniversityTime: new FormControl(center.AtUniversityTime)
              }));
            });
          } else {
            // Ensure at least one empty row if no regional centers exist
            regionalCenterArray.push(this.fb.group({
              TsdId: new FormControl(''),
              AtUniversityCenters: new FormControl(''), // Show empty input
              AtUniversity: new FormControl(''),
              AtUniversityTime: new FormControl(''),
            }));
          }

          this.DateArray.push(rowGroup);
        });

        console.log('All collected TsdIds:', this.allTsdIds);

      } else {
        // Reset form if no data found and add an empty row
        this.allTsdIds=[];
        this.DateArray.clear();
        this.addNewRow(); // Ensure at least one empty row
      }
    });
  }


  selectCourses() {
    this.prepopulatedData()
  }


  getTentativeCourse(e) {
    this.spinner.show();
    let payload = {}
    payload['SnNo'] = e.TsmSnNo;
    payload['Schedule'] = e.TsmScheduleType;
    payload['TsmCircularId'] = e.TsmCircularId
    payload['IsReportRequest'] = '';
    this.umsService.getTentative(payload).subscribe(res => {
      if (res.data && res.data.length > 0) {
        this.spinner.hide();
        console.log('res.data', res.data)
        this.coursesList = res.data;
        this.filteredCoursesList = this.coursesList.slice();
      }
      else {
        this.spinner.hide();
        this.coursesList = []; // Reset courses list
        this.selectedSerialNo = null; // Reset selected course name
        this.selectedTentativeDate = null; // Reset selected date
      }
    })
  }
  onSerialNoSelect(event: MatSelectChange) {
    const selectedSrNo = event.value;
    this.selectedSerialNo = this.convertToRoman(selectedSrNo.SrNo);
    // this.selectedTentativeDate = selectedSrNo.TentativeDate;
    // this.originalTentativeDate = selectedSrNo.TentativeDate;
    // this.selectedTentativeDate = this.datePipe.transform(selectedSrNo.TentativeDate, 'dd/MM/yyyy');
    this.selectedTentativeDate = this.formatTentativeDates(selectedSrNo.TentativeDate);
  }

  getSrNo(e) {
    this.CircularId = e.TsmCircularId
    this.spinner.show();
    let payload = {}
    payload['SnNo'] = e.TsmSnNo;
    payload['Schedule'] = e.TsmScheduleType;
    payload['TsmCircularId'] = e.TsmCircularId
    payload['IsReportRequest'] = '';
    this.umsService.getTentative(payload).subscribe(res => {
      if (res.data && res.data.length > 0) {
        this.spinner.hide();
        console.log('res.data', res.data)
        // this.SrNoList = res.data;
        // this.filteredSrNoList = this.SrNoList.slice();
        console.log('Original Data:', res.data);

        // Grouping SrNo and merging TentativeDate
        this.SrNoList = this.groupBySrNo(res.data);
        this.filteredSrNoList = [...this.SrNoList];
      }
      else {
        this.spinner.hide();
        this.SrNoList = []; // Reset courses list
        this.selectedSerialNo = null; // Reset selected course name
        this.selectedTentativeDate = null; // Reset selected date
      }
    })
  }
  groupBySrNo(data: any[]): any[] {
    let groupedData: { [key: number]: { SrNo: number; TentativeDate: Set<string> } } = {};

    data.forEach(item => {
      let srNoKey = item.SrNo;

      if (!groupedData[srNoKey]) {
        groupedData[srNoKey] = {
          SrNo: item.SrNo,
          // SnName: item.SnName,
          TentativeDate: new Set() // Using Set to store unique dates
        };
      }

      groupedData[srNoKey].TentativeDate.add(item.TentativeDate); // Automatically removes duplicates
    });

    // Formatting the output properly
    return Object.values(groupedData).map(item => ({
      SrNo: item.SrNo,
      // SnName: item.SnName,
      TentativeDate: Array.from(item.TentativeDate).join(' and ')  // Convert Set to array and join with ' & '
    }));
  }

  formatTentativeDates(dateString: string): string {
    return dateString
      .split(" and ") // Split multiple dates
      .map(date => new Date(date).toLocaleDateString('en-GB')) // Convert each date to dd/MM/yyyy
      .join(" and "); // Join formatted dates back
  }
  // groupBySrNo(data: any[]): any[] {
  //   let groupedData: { [key: number]: { SrNo: number; SnName: string; TentativeDate: string[] } } = {};

  //   data.forEach(item => {
  //     let srNoKey = item.SrNo;

  //     if (!groupedData[srNoKey]) {
  //       groupedData[srNoKey] = {
  //         SrNo: item.SrNo,
  //         SnName: item.SnName,
  //         TentativeDate: []
  //       };
  //     }

  //     if (!groupedData[srNoKey].TentativeDate.includes(item.TentativeDate)) {
  //       groupedData[srNoKey].TentativeDate.push(item.TentativeDate);
  //     }
  //   });

  //   // Ensure proper typing when mapping over the object values
  //   return Object.values(groupedData).map((item: { SrNo: number; SnName: string; TentativeDate: string[] }) => ({
  //     SrNo: item.SrNo,
  //     SnName: item.SnName,
  //     TentativeDate: item.TentativeDate.join(' and ')  // Formatting
  //   }));
  // }



  dateValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (!control.value || !this.selectedTentativeDate) {
      return null;
    }
    const selectedDate = new Date(control.value);
    const maxDate = new Date(this.selectedTentativeDate);

    return selectedDate > maxDate ? { dateExceeded: true } : null;
  }

  datechange(i) {
    let taskListArrays = this.TentativeDetailsForm.get('DateArray') as FormArray;
    let atCollegeControl = taskListArrays.controls[i].get('AtCollege');
    let atRegionalCenterControl = taskListArrays.controls[i].get('AtRegionalCenter');
    let atUniversityControl = taskListArrays.controls[i].get('AtUniversity');
    let AtCollegeDate = atCollegeControl.value ? new Date(atCollegeControl.value) : null;
    let AtRegionalCenterDate = atRegionalCenterControl?.value ? new Date(atRegionalCenterControl.value) : null;
    let AtUniversityDate = atUniversityControl?.value ? new Date(atUniversityControl.value) : null;
    // let maxAllowedDate = this.selectedTentativeDate ? new Date(this.selectedTentativeDate) : null;


    if (!this.selectedTentativeDate || !AtCollegeDate) return;

// Convert "DD/MM/YYYY" to "YYYY-MM-DD" before creating Date objects
let tentativeDates = this.selectedTentativeDate.split(" and ").map(dateStr => {
  let parts = dateStr.trim().split("/"); // Split by "/"
  return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`); // Rearrange to "YYYY-MM-DD"
});

// Find min and max tentative dates
let minTentativeDate = new Date(Math.min(...tentativeDates.map(date => date.getTime())));
let maxTentativeDate = new Date(Math.max(...tentativeDates.map(date => date.getTime())));

// Validate: Selected date should be less than both tentative dates
if (AtCollegeDate > minTentativeDate || AtCollegeDate > maxTentativeDate) {
  let formattedMinDate = minTentativeDate.toLocaleDateString('en-GB'); // Format as "DD/MM/YYYY"
  let formattedMaxDate = maxTentativeDate.toLocaleDateString('en-GB');

  let message = tentativeDates.length > 1
  ? `Select Date Less Than Tentative Exam Dates ${formattedMinDate} and ${formattedMaxDate}`
  : `Select Date Less Than Tentative Exam Date ${formattedMinDate}`;

let data = {
  message: message,
  title: 'Information',
  icon: 'fas fa-close'
};
  // let data = {
  //   message: `Select Date Less Than Tentative Exam Date ${formattedMinDate} and ${formattedMaxDate}`,
  //   title: 'Information',
  //   icon: 'fas fa-close'
  // };
  this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

  atCollegeControl.setValue(''); // Reset input
  return;
}
    // if (!this.selectedTentativeDate || !AtCollegeDate) return;

    // // Extract all tentative dates
    // let tentativeDates = this.selectedTentativeDate.split(" and ").map(dateStr => new Date(dateStr.trim()));

    // // Find the min and max tentative dates
    // let minTentativeDate = new Date(Math.min(...tentativeDates.map(date => date.getTime())));
    // let maxTentativeDate = new Date(Math.max(...tentativeDates.map(date => date.getTime())));

    // // Validate: Selected date should be less than both tentative dates
    // if (AtCollegeDate > minTentativeDate || AtCollegeDate > maxTentativeDate) {
    //   let formattedMinDate = minTentativeDate.toLocaleDateString('en-GB'); // Format as "DD/MM/YYYY"
    //   let formattedMaxDate = maxTentativeDate.toLocaleDateString('en-GB');

    //   let data = {
    //     message: `Select Date Less Than Tentative Exam Date ${formattedMinDate} and ${formattedMaxDate}`,
    //     title: 'Information',
    //     icon: 'fas fa-close'
    //   };
    //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    //   atCollegeControl.setValue(''); // Reset input
    //   return;
    // }

    //  // Convert selectedTentativeDate (which might have multiple dates) into an array
    //  let tentativeDatesArray = this.selectedTentativeDate ? this.selectedTentativeDate.split(' & ').map(date => new Date(date)) : [];

    //  // Find the latest tentative date
    //  let maxAllowedDate = tentativeDatesArray.length > 0 ? new Date(Math.max(...tentativeDatesArray.map(d => d.getTime()))) : null;
    // // Validate AtCollege Date <= selectedTentativeDate
    // if (AtCollegeDate && maxAllowedDate) {
    //   if (AtCollegeDate >= maxAllowedDate) {
    //     let formattedDate = maxAllowedDate.toLocaleDateString('en-GB'); // Format as "DD/MM/YYYY"
    //     let data = {
    //       message: `Select Date Less Than Tentative Exam Date (${formattedDate})`,
    //       title: 'Information',
    //       icon: 'fas fa-close'
    //     };
    //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
    //       AlertBoxComponent,
    //       data
    //     );
    //     atCollegeControl.setValue('');
    //     // atCollegeControl.setErrors({ dateError: true });
    //   } else {
    //     // atCollegeControl.setErrors(null);
    //   }
    // }
    // if (AtCollegeDate && maxAllowedDate && AtCollegeDate > maxAllowedDate) {
    //   atCollegeControl.setErrors({ dateExceeded: true });
    // } else {
    //   atCollegeControl.setErrors(null);
    // }
    let validationMessage = '';
    if (i === 1) {
      validationMessage = 'Date Should Be Greater Than Without Late Fee Date';
    } else if (i === 2) {
      validationMessage = 'Date Should Be Greater Than With Late Fee Date';
    } else {
      validationMessage = 'Select a valid date';
    }
    if (i > 0) { // Ensure there is a previous row to compare
      let prevAtCollegeControl = taskListArrays.controls[i - 1].get('AtCollege');
      let prevAtCollegeDate = prevAtCollegeControl.value ? new Date(prevAtCollegeControl.value) : null;

      if (prevAtCollegeDate && AtCollegeDate) {
        if (prevAtCollegeDate > AtCollegeDate) {  // Next row must be GREATER than previous row
          let formattedPrevDate = prevAtCollegeDate.toLocaleDateString('en-GB');
          let data = {
            message: `${validationMessage} (${formattedPrevDate})`,
            title: 'Information',
            icon: 'fas fa-close'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          atCollegeControl.setValue('');
        }
      }
    }
    // if (i > 0) { // Ensure there is a previous row to compare
    //   let prevAtCollegeControl = taskListArrays.controls[i - 1].get('AtCollege');
    //   let prevAtCollegeDate = prevAtCollegeControl.value ? new Date(prevAtCollegeControl.value) : null;

    //   if (prevAtCollegeDate && AtCollegeDate) {
    //     if (prevAtCollegeDate >= AtCollegeDate) {  // Next row must be GREATER than previous row
    //       let formattedPrevDate = prevAtCollegeDate.toLocaleDateString('en-GB');
    //       let data = {
    //         message: `Select Date Greater Than Previous Row's Date (${formattedPrevDate})`,
    //         title: 'Information',
    //         icon: 'fas fa-close'
    //       };
    //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //       atCollegeControl.setValue('');
    //       // atCollegeControl.setErrors({ prevDateError: true });
    //     }
    //   }
    // }
    // if (AtCollegeDate && AtRegionalCenterDate && AtCollegeDate > AtRegionalCenterDate) {
    //   let data = {
    //     message: `At Regional Center date must be greater than or equal to At College date (${AtCollegeDate.toLocaleDateString('en-GB')})`,
    //     title: 'Information',
    //     icon: 'fas fa-close'
    //   };
    //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //   atRegionalCenterControl.setValue('');
    //   // atRegionalCenterControl.setErrors({ dateError: true });
    //   return;
    // }

    // // Validation: At Regional Center < At University
    // if (AtRegionalCenterDate && AtUniversityDate && AtRegionalCenterDate >= AtUniversityDate) {
    //   let data = {
    //     message: `At University date must be greater than At Regional Center date (${AtRegionalCenterDate.toLocaleDateString('en-GB')})`,
    //     title: 'Information',
    //     icon: 'fas fa-close'
    //   };
    //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //   atUniversityControl.setValue('');
    //   // atUniversityControl.setErrors({ dateError: true });
    //   return;
    // }
    // if (AtCollegeDate && AtUniversityDate && AtCollegeDate >= AtUniversityDate) {
    //   let data = {
    //     message: `At University date must be greater than At College date (${AtCollegeDate.toLocaleDateString('en-GB')})`,
    //     title: 'Information',
    //     icon: 'fas fa-close'
    //   };
    //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //   atUniversityControl.setValue('');
    //   // atUniversityControl.setErrors({ dateError: true });
    //   return;
    // }
    // Clear errors if all validations pass
    atCollegeControl.setErrors(null);
    atRegionalCenterControl.setErrors(null);
    atUniversityControl.setErrors(null);
    // }
  }

  datechange1(i) {
    let taskListArrays = this.TentativeDetailsForm.get('DateArray') as FormArray;
    let atCollegeControl = taskListArrays.controls[i].get('AtCollege');
    let atRegionalCenterControl = taskListArrays.controls[i].get('AtRegionalCenter');
    let atUniversityControl = taskListArrays.controls[i].get('AtUniversity');
    let AtCollegeDate = atCollegeControl?.value ? new Date(atCollegeControl.value) : null;
    let AtRegionalCenterDate = atRegionalCenterControl.value ? new Date(atRegionalCenterControl.value) : null;
    let AtUniversityDate = atUniversityControl?.value ? new Date(atUniversityControl.value) : null;
    // let maxAllowedDate = this.selectedTentativeDate ? new Date(this.selectedTentativeDate) : null;
    // Validate AtCollege Date <= selectedTentativeDate

    if (!this.selectedTentativeDate || !AtRegionalCenterDate) return;

// Convert "DD/MM/YYYY" to "YYYY-MM-DD" before creating Date objects
let tentativeDates = this.selectedTentativeDate.split(" and ").map(dateStr => {
  let parts = dateStr.trim().split("/"); // Split by "/"
  return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`); // Rearrange to "YYYY-MM-DD"
});

// Find min and max tentative dates
let minTentativeDate = new Date(Math.min(...tentativeDates.map(date => date.getTime())));
let maxTentativeDate = new Date(Math.max(...tentativeDates.map(date => date.getTime())));

// Validate: Selected date should be less than both tentative dates
if (AtRegionalCenterDate > minTentativeDate || AtRegionalCenterDate > maxTentativeDate) {
  let formattedMinDate = minTentativeDate.toLocaleDateString('en-GB'); // Format as "DD/MM/YYYY"
  let formattedMaxDate = maxTentativeDate.toLocaleDateString('en-GB');
  
  let message = tentativeDates.length > 1
  ? `Select Date Less Than Tentative Exam Dates ${formattedMinDate} and ${formattedMaxDate}`
  : `Select Date Less Than Tentative Exam Date ${formattedMinDate}`;

let data = {
  message: message,
  title: 'Information',
  icon: 'fas fa-close'
};
  //
  // let data = {
  //   message: `Select Date Less Than Tentative Exam Date ${formattedMinDate} and ${formattedMaxDate}`,
  //   title: 'Information',
  //   icon: 'fas fa-close'
  // };
  this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

  atRegionalCenterControl.setValue(''); // Reset input
  return;
}

    // if (!this.selectedTentativeDate || !AtRegionalCenterDate) return;

    // // Extract all tentative dates
    // let tentativeDates = this.selectedTentativeDate.split(" and ").map(dateStr => new Date(dateStr.trim()));

    // // Find the min and max tentative dates
    // let minTentativeDate = new Date(Math.min(...tentativeDates.map(date => date.getTime())));
    // let maxTentativeDate = new Date(Math.max(...tentativeDates.map(date => date.getTime())));

    // // Validate: Selected date should be less than both tentative dates
    // if (AtRegionalCenterDate > minTentativeDate || AtRegionalCenterDate > maxTentativeDate) {
    //   let formattedMinDate = minTentativeDate.toLocaleDateString('en-GB'); // Format as "DD/MM/YYYY"
    //   let formattedMaxDate = maxTentativeDate.toLocaleDateString('en-GB');

    //   let data = {
    //     message: `Select Date Less Than Tentative Exam Date ${formattedMinDate} and ${formattedMaxDate}`,
    //     title: 'Information',
    //     icon: 'fas fa-close'
    //   };
    //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    //   atRegionalCenterControl.setValue(''); // Reset input
    //   return;
    // }


    // if (AtRegionalCenterDate && maxAllowedDate) {
    //   if (AtRegionalCenterDate >= maxAllowedDate) {
    //     let formattedDate = maxAllowedDate.toLocaleDateString('en-GB'); // Format as "DD/MM/YYYY"
    //     let data = {
    //       message: `Select Date Less Than Tentative Exam Date (${formattedDate})`,
    //       title: 'Information',
    //       icon: 'fas fa-close'
    //     };
    //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
    //       AlertBoxComponent,
    //       data
    //     );
    //     atRegionalCenterControl.setValue('');
    //     // atRegionalCenterControl.setErrors({ dateError: true });
    //   } else {
    //     // atRegionalCenterControl.setErrors(null);
    //   }
    // }
    let validationMessage = '';
    if (i === 1) {
      validationMessage = 'Date Should Be Greater Than Without Late Fee Date';
    } else if (i === 2) {
      validationMessage = 'Date Should Be Greater Than With Late Fee Date';
    } else {
      validationMessage = 'Select a valid date';
    }
    if (i > 0) { // Ensure there is a previous row to compare
      let prevatRegionalCenterControl = taskListArrays.controls[i - 1].get('AtRegionalCenter');
      let prevAtRegionalCenterDate = prevatRegionalCenterControl.value ? new Date(prevatRegionalCenterControl.value) : null;

      if (prevAtRegionalCenterDate && AtRegionalCenterDate) {
        if (prevAtRegionalCenterDate > AtRegionalCenterDate) {  // Next row must be GREATER than previous row
          let formattedPrevDate = prevAtRegionalCenterDate.toLocaleDateString('en-GB');
          let data = {
            message: `${validationMessage} (${formattedPrevDate})`,
            title: 'Information',
            icon: 'fas fa-close'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          atRegionalCenterControl.setValue('');
        }
      }
    }
  }


  datechange2(i: number, j: number) {
    let taskListArray = this.TentativeDetailsForm.get('DateArray') as FormArray;
    let regionalCenterArray = taskListArray.controls[i].get('regionalCenterArray') as FormArray;
    let atUniversityControl = regionalCenterArray.controls[j].get('AtUniversity');

    let AtUniversityDate = atUniversityControl.value ? new Date(atUniversityControl.value) : null;
    let maxAllowedDate = this.selectedTentativeDate ? new Date(this.selectedTentativeDate) : null;


    if (!this.selectedTentativeDate || !AtUniversityDate) return;

// Convert "DD/MM/YYYY" to "YYYY-MM-DD" before creating Date objects
let tentativeDates = this.selectedTentativeDate.split(" and ").map(dateStr => {
  let parts = dateStr.trim().split("/"); // Split by "/"
  return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`); // Rearrange to "YYYY-MM-DD"
});

// Find min and max tentative dates
let minTentativeDate = new Date(Math.min(...tentativeDates.map(date => date.getTime())));
let maxTentativeDate = new Date(Math.max(...tentativeDates.map(date => date.getTime())));

// Validate: Selected date should be less than both tentative dates
if (AtUniversityDate > minTentativeDate || AtUniversityDate > maxTentativeDate) {
  let formattedMinDate = minTentativeDate.toLocaleDateString('en-GB'); // Format as "DD/MM/YYYY"
  let formattedMaxDate = maxTentativeDate.toLocaleDateString('en-GB');
 
 
  let message = tentativeDates.length > 1
  ? `Select Date Less Than Tentative Exam Dates ${formattedMinDate} and ${formattedMaxDate}`
  : `Select Date Less Than Tentative Exam Date ${formattedMinDate}`;

let data = {
  message: message,
  title: 'Information',
  icon: 'fas fa-close'
};
  //
  // let data = {
  //   message: `Select Date Less Than Tentative Exam Date ${formattedMinDate} and ${formattedMaxDate}`,
  //   title: 'Information',
  //   icon: 'fas fa-close'
  // };
  this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

  atUniversityControl.setValue(''); // Reset input
  return;
}

    // if (!this.selectedTentativeDate || !AtUniversityDate) return;

    // // Extract all tentative dates
    // let tentativeDates = this.selectedTentativeDate.split(" and ").map(dateStr => new Date(dateStr.trim()));

    // // Find the min and max tentative dates
    // let minTentativeDate = new Date(Math.min(...tentativeDates.map(date => date.getTime())));
    // let maxTentativeDate = new Date(Math.max(...tentativeDates.map(date => date.getTime())));

    // // Validate: Selected date should be less than both tentative dates
    // if (AtUniversityDate >= minTentativeDate || AtUniversityDate >= maxTentativeDate) {
    //   let formattedMinDate = minTentativeDate.toLocaleDateString('en-GB'); // Format as "DD/MM/YYYY"
    //   let formattedMaxDate = maxTentativeDate.toLocaleDateString('en-GB');

    //   let data = {
    //     message: `Select Date Less Than Tentative Exam Date ${formattedMinDate} and ${formattedMaxDate}`,
    //     title: 'Information',
    //     icon: 'fas fa-close'
    //   };
    //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    //   atUniversityControl.setValue(''); // Reset input
    //   return;
    // }


    // if (AtUniversityDate) {
    // ✅ Convert to DD/MM/YYYY hh:mm A format
    // let formattedAtUniversityDate = moment(AtUniversityDate).format('DD/MM/YYYY hh:mm A');
    // console.log('Formatted Date:', formattedAtUniversityDate);

    // if (maxAllowedDate && AtUniversityDate >= maxAllowedDate) {
    //   let formattedMaxDate = moment(maxAllowedDate).format('DD/MM/YYYY');
    //   let data = {
    //     message: `Select Date Less Than Tentative Exam Date (${formattedMaxDate})`,
    //     title: 'Information',
    //     icon: 'fas fa-close'
    //   };

    //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //   atUniversityControl.setValue('');
    //   atUniversityControl.setErrors({ dateError: true });
    //   return;
    // } else {
    //   atUniversityControl.setErrors(null);
    // }
    // }

    let validationMessage = '';
    if (i === 1) {
      validationMessage = 'Date Should Be Greater Than Without Late Fee Date';
    } else if (i === 2) {
      validationMessage = 'Date Should Be Greater Than With Late Fee Date';
    } else {
      validationMessage = 'Select a valid date';
    }

    if (i > 0) {
      let prevAtUniversityControl = taskListArray.controls[i - 1].get('regionalCenterArray') as FormArray;
      let prevUniversityControl = prevAtUniversityControl.controls[j]?.get('AtUniversity');
      let prevAtUniversityDate = prevUniversityControl?.value ? new Date(prevUniversityControl.value) : null;

      if (prevAtUniversityDate && AtUniversityDate && prevAtUniversityDate > AtUniversityDate) {
        let formattedPrevDate = moment(prevAtUniversityDate).format('DD/MM/YYYY');
        let data = {
          message: `${validationMessage} (${formattedPrevDate})`,
          title: 'Information',
          icon: 'fas fa-close'
        };

        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        atUniversityControl.setValue('');
        atUniversityControl.setErrors({ prevDateError: true });
        return;
      }
    }

    if (j > 0) {
      let prevRowUniversityControl = regionalCenterArray.controls[j - 1]?.get('AtUniversity');
      let prevRowAtUniversityDate = prevRowUniversityControl?.value ? new Date(prevRowUniversityControl.value) : null;

      if (prevRowAtUniversityDate && AtUniversityDate && prevRowAtUniversityDate > AtUniversityDate) {
        let formattedPrevDate = moment(prevRowAtUniversityDate).format('DD/MM/YYYY');
        let data = {
          message: `AtUniversity Date Must Be Greater Than The Previous Row's Date`,
          title: 'Information',
          icon: 'fas fa-close'
        };

        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        atUniversityControl.setValue('');
        atUniversityControl.setErrors({ prevRowDateError: true });
        return;
      }
    }

    // Get all selected dates from all SR.NO sections
    let allDates: Date[] = [];
    taskListArray.controls.forEach(section => {
      let regionalCenterArray = section.get('regionalCenterArray') as FormArray;
      let sectionDates = regionalCenterArray.controls.map(ctrl => ctrl.get('AtUniversity')?.value)
        .filter(date => date)
        .map(dateStr => new Date(dateStr));
      allDates.push(...sectionDates);
    });

    if (!AtUniversityDate || allDates.length === 0) return;

    // Get the minimum tentative date across all sections
    let minTentativeDates = new Date(Math.min(...allDates.map(date => date.getTime())));

    if (AtUniversityDate < minTentativeDates) {
      let formattedMinDate = minTentativeDates.toLocaleDateString('en-GB');

      let data = {
        message: `Selected Date must be greater than or equal to ${formattedMinDate}`,
        title: 'Validation Error',
        icon: 'fas fa-exclamation-triangle'
      };

      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      atUniversityControl.setValue('');
      atUniversityControl.setErrors({ dateError: true });
      return;
    } else {
      atUniversityControl.setErrors(null);
    }

  }

  isOptionDisabled(optionIndex: number, rowIndex: number): boolean {
    return optionIndex !== rowIndex; // Allows only the option at the same index as the row
  }


  Print() {
    let submitpayload = this.TentativeDetailsForm.value;
    console.log('submitpayload', submitpayload)
    let payload1 = {}
    payload1['TsmCircularId'] = this.TentativeDetailsForm.value.TenCircularNo.TsmCircularId,
      // payload1['SrNo'] = this.TentativeDetailsForm.value.SrNo.SrNo
      // payload1['TenCircularDate'] = this.TentativeDetailsForm.value.TenCircularDate ? this.TentativeDetailsForm.value.TenCircularDate: '';
      // payload1['TenCourses'] = this.TentativeDetailsForm.value.TenCourses ? this.TentativeDetailsForm.value.TenCourses: '';
      // payload1['CircularNumber'] = this.TentativeForm.value.CircularNumber
      // payload['CircularDate'] = this.TentativeForm.value.CircularDate
      console.log('payload1', payload1)
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 302,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": '',
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  convertToRoman(num: number): string {
    const romanNumerals: { value: number; numeral: string }[] = [
      { value: 1000, numeral: "M" },
      { value: 900, numeral: "CM" },
      { value: 500, numeral: "D" },
      { value: 400, numeral: "CD" },
      { value: 100, numeral: "C" },
      { value: 90, numeral: "XC" },
      { value: 50, numeral: "L" },
      { value: 40, numeral: "XL" },
      { value: 10, numeral: "X" },
      { value: 9, numeral: "IX" },
      { value: 5, numeral: "V" },
      { value: 4, numeral: "IV" },
      { value: 1, numeral: "I" },
    ];
  
    let roman = "";
    for (const item of romanNumerals) {
      while (num >= item.value) {
        roman += item.numeral;
        num -= item.value;
      }
    }
    return roman;
  }


}
